// Short answer first (RAG_SHORT_ANSWER, 2026-10-28): the answer model writes a
// 1–3 sentence `short_answer`; the chat shows it and folds the full answer under
// "Details". Nothing is removed — the full answer stays one click away.
// With RAG_SHORT_ANSWER_FIRST it streams before the full answer, so the layout is
// chosen as soon as it arrives and never changes at the end (user decision
// 2026-10-28: fold whenever a short answer exists, also for short answers).
import { visibleWords } from './answerCollapse.js';
import { DANGER_RX } from './safetyFold.js';

export function fullAnswerText(message) {
  const secs = Array.isArray(message && message.answerSections) ? message.answerSections : [];
  const body = secs.map((s) => (typeof s.content === 'string' ? s.content : '')).join('\n\n');
  return body || (message && message.text) || '';
}

export function shouldShowShort(message) {
  if (!message) return false;
  return typeof message.shortAnswer === 'string' && message.shortAnswer.trim() !== '';
}

export function detailsLabel(fullMd, { streaming = false } = {}) {
  if (streaming) return 'Details: vollständige Antwort wird geschrieben …';
  const n = visibleWords(fullMd);
  return `Details: vollständige Antwort (${n} Wörter)${DANGER_RX.test(fullMd || '') ? ' – enthält GEFAHR-Hinweis' : ''}`;
}
